import gql from 'graphql-tag';

export default gql`
  mutation unsaveVendorVariant(
    $vendorVariantId: ID!
  ) {
    unsaveVendorVariant(
      vendorVariantId: $vendorVariantId
    )
  }
`;
